var map = {
	"./banner/store.js": "117f",
	"./comment/store.js": "4489",
	"./magazine/store.js": "0aa7",
	"./puzzle/store.js": "e1c3",
	"./settings/store.js": "dd3c",
	"./user/store.js": "1053"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fcda";